import { translate } from "app/filters/i18nFilter";
import type { SuppressionList } from "app/pages/sales-intelligence/sub-modules/management/components/types";
import dateTimeService from "app/services/date-time/dateTimeService";
import { MM_DD_YY } from "app/services/date-time/formats";

import { SL_ALL_LISTS_LABEL, SL_LIST_ITEM_LABEL } from "../../constants/translations";

import {
    StyledAllSuppressionListsLabel,
    StyledAllSuppressionListsTooltip,
    StyledSuppressionListItem,
    StyledSuppressionListItemName,
    StyledSuppressionListItemSummary,
    StyledSuppressionLists,
} from "./styles";

interface IProps {
    suppressionLists: SuppressionList[];
}

export const AllSuppressionListsLabel = ({ suppressionLists }: IProps) => {
    const listsCount = suppressionLists.length;

    const suppressionListsView = (
        <StyledSuppressionLists>
            {suppressionLists.map((list) => {
                const ownerName = `${list.ownerFirstName} ${list.ownerLastName}`;
                const updated = dateTimeService.formatWithMoment(list.created, MM_DD_YY);

                return (
                    <StyledSuppressionListItem key={list.id}>
                        <StyledSuppressionListItemName>&quot;{list.name}&quot;</StyledSuppressionListItemName>
                        <StyledSuppressionListItemSummary>
                            {translate(SL_LIST_ITEM_LABEL, { ownerName, updated })}
                        </StyledSuppressionListItemSummary>
                    </StyledSuppressionListItem>
                );
            })}
        </StyledSuppressionLists>
    );

    return (
        <StyledAllSuppressionListsTooltip
            enabled={listsCount > 0}
            content={suppressionListsView}
        >
            <StyledAllSuppressionListsLabel fontVariant="button">
                {translate(SL_ALL_LISTS_LABEL, { listsCount })}
            </StyledAllSuppressionListsLabel>
        </StyledAllSuppressionListsTooltip>
    );
};
